import React, { createContext, useContext, useState, useEffect } from 'react';

const SignupContext = createContext();

export function useSignup() {
  return useContext(SignupContext);
}

export function SignupProvider({ children }) {
  const [isSignupModalOpen, setIsSignupModalOpen] = useState(false);
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
  const [isVerifying, setIsVerifying] = useState(false);
  const [verificationToken, setVerificationToken] = useState('');

  const handleSignupClick = () => {
    setIsSignupModalOpen(true);
    setIsLoginModalOpen(false);
  };

  const handleLoginClick = () => {
    setIsSignupModalOpen(false);
    // Dispatch an event to trigger the login modal
    window.dispatchEvent(new Event('loginFromSignup'));
  };

  const handleCloseSignup = () => {
    setIsSignupModalOpen(false);
    setIsVerifying(false);
    setVerificationToken('');
  };

  const handleCloseLogin = () => {
    setIsLoginModalOpen(false);
  };
  /*
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    if (token) {
      setVerificationToken(token);
      setIsVerifying(true);
      setIsSignupModalOpen(true);
      // Clean up URL
      window.history.replaceState({}, '', window.location.pathname);
    }
  }, []);
  */
  const value = {
    isSignupModalOpen,
    isLoginModalOpen,
    isVerifying,
    verificationToken,
    handleSignupClick,
    handleLoginClick,
    handleCloseSignup,
    handleCloseLogin
  };

  return (
    <SignupContext.Provider value={value}>
      {children}
    </SignupContext.Provider>
  );
}